import styled from 'styled-components';
import { opoButtonStyles, opoCardStyles, opoFormStyles } from '@nkr/views/opo/landing-page/opo-styles';

export const VerifyPage = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
    padding: 10vh 16px 40px;
    background: #EEF3F9;
`;

export const VerifyCard = styled.div`
    ${opoCardStyles}
    ${opoFormStyles}

    width: 100%;
    max-width: 480px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    font-size: 14px;
    color: #1F2A37;

    .verify-card-header {
        padding: 14px 20px;
        border-bottom: 1px solid #EEF1F5;
    }

    .verify-card-header .step {
        display: block;
        margin-bottom: 2px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #6B7A8F;
    }

    .verify-card-header h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #1F2A37;
    }

    .verify-card-body {
        padding: 16px 20px;
    }

    .verify-card-body p {
        margin-bottom: 14px;
    }

    .verify-card-footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 12px 20px;
        border-top: 1px solid #EEF1F5;

        ${opoButtonStyles}
    }

    .form-group:last-child {
        margin-bottom: 0;
    }

    .control-label {
        font-size: 13px;
    }

    .form-control {
        font-size: 14px;
    }

    .input-group .form-control {
        border-radius: 8px 0 0 8px;
    }

    .input-group-btn > .btn {
        height: 32px;
        border-color: #D5DBE3;
        border-radius: 0 8px 8px 0;
        color: #3A4756;
    }

    .has-error .control-label {
        color: #A3201A;
    }

    .has-error .form-control,
    .has-error .form-control:focus {
        border-color: #A3201A;
    }

    .has-error .form-control:focus {
        box-shadow: 0 0 0 3px rgba(163, 32, 26, 0.18);
    }

    .help-block {
        margin: 4px 0 0;
        font-size: 13px;
    }

    .has-error .help-block {
        color: #A3201A;
    }

    .btn-link {
        padding: 0;
        vertical-align: baseline;
    }

    .notice,
    .error-notice {
        margin-bottom: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
    }

    .notice {
        border: 1px solid #B9D3EE;
        border-left: 4px solid #337AB7;
        background: #E8F1FB;
        color: #16365A;
    }

    .error-notice {
        border: 1px solid #F1C2BF;
        border-left: 4px solid #A3201A;
        background: #FCEDEC;
        color: #A3201A;
    }

    .username {
        display: flex;
        flex-direction: column;
        margin-bottom: 14px;
        padding: 10px 14px;
        border: 1px solid #E3E8EF;
        border-radius: 8px;
        background: #FAFBFC;
    }

    .username > .k {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #6B7A8F;
    }

    .username > .v {
        font-size: 16px;
        font-weight: 700;
        color: #16365A;
    }
`;
